import { fb, validators } from '../../lib/form';

export function getModel(data) {

  const productList = [
    'Canola', 'Beans', 'Barley', 'Peas', 'Lentils', 'Wheat'
  ].map(x => { return { name: x, value: x } })

  const subscribeList = [
    'Subscribe', 'Un-Subscribe'
  ].map(x => { return { name: x, value: x } })

  const model = fb.group({
    ngrNumber: [data.ngrNumber || '', [validators.Required()], { label: 'NGR number', type: 'text' }],
    tradingName: [data.tradingName || '', [validators.Required()], { label: 'Trading name', type: 'text' }],
    contactPerson: [data.contactPerson || '', [validators.Required()], { label: 'Contact person', type: 'text' }],
    phone: [data.phone || '', [validators.Required()], { label: 'Telephone', type: 'text' }],

    products: [data.products || '', [], { label: 'Pricing you are interested in', type: 'checkboxList', 
      options: productList, style: { inline: true } }],

    productOther: [data.productOther || '', [], { label: 'Other(please list)', type: 'text' }],
    deliveryTerminal: [data.deliveryTerminal || '', [validators.Required()], { label: 'Closest Delivery Terminal (Adelaide, Portland , Lincoln, Wallaroo etc)', type: 'text' }],
    
    smsService: [data.smsService || 'Subscribe', [], { label: null, type: 'radioList', options: subscribeList, style: { inline: true } }],
    //faxService: [data.faxService || 'Subscribe', [], { label: null, type: 'radioList', options: subscribeList, style: { inline: true } }],
    emailService: [data.emailService || 'Subscribe', [], { label: null, type: 'radioList', options: subscribeList, style: { inline: true } }],
    		
    email: [data.email || '', [validators.Email()], { label: 'Email address', type: 'email' }],
    //fax: [data.fax || '', [], { label: 'Fax number', type: 'text' }],
    mobile: [data.mobile || '', [], { label: 'Mobile number', type: 'text' }],
    
  });

  return model;
}